import React, { useEffect, useState, useMemo, useRef } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import "../Style/Dashboard.css";
import "../Style/QRpage.css";
import { QrCode, Smartphone } from "lucide-react";
import axios from "axios";
import QRCode from "qrcode";
import { BASE_URL } from "../Apis/apiConfig";

const QRpage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  const canvasRef = useRef(null);

  const societyName = localStorage.getItem("society") || "Sunrise Residency";

  // ✅ API CALL ONCE
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    axios
      .get(`${BASE_URL}/api/employee/get-all-services-by-security-guard`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { societyName },
      })
      .then((res) => {
        setEmployees(res.data || []);
        setSelectedIndex(0);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [societyName]);

  const selectedEmployee = employees[selectedIndex];

  // ✅ PHONE ALWAYS CHANGES
  const urlToEncode = useMemo(() => {
    return selectedEmployee?.employeePhone
      ? `tel:${selectedEmployee.employeePhone}`
      : "";
  }, [selectedEmployee]);

  // ✅ QR UPDATE
  useEffect(() => {
    if (!urlToEncode || !canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    QRCode.toCanvas(canvas, urlToEncode, { width: 280 });
  }, [urlToEncode]);

  return (
    <div className="app-container">
      <Header toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />

      <div className="main-layout">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

        <main className="content-area">
          <SubHeader />

          <div className="qr-page-wrapper">
            <div className="qr-content">

              <div className="qr-header">
                <QrCode size={24} />
                <h1>Employee Phone QR</h1>
                <p>Select employee to change phone</p>
              </div>

              {/* ✅ DROPDOWN */}
              <div className="employee-select">
                {loading ? (
                  <p>Loading...</p>
                ) : (
                  <select
                    value={selectedIndex}
                    onChange={(e) => setSelectedIndex(Number(e.target.value))}
                  >
                    {employees.map((emp, index) => (
                      <option key={emp.employeeId} value={index}>
                        {emp.employeeName}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              {/* ✅ QR */}
              <canvas ref={canvasRef} />

              {/* ✅ PHONE ALWAYS MATCHES NAME */}
              {selectedEmployee?.employeePhone && (
                <p>📞 {selectedEmployee.employeePhone}</p>
              )}

              <div className="qr-info">
                <Smartphone size={16} />
                <span>Scan QR to call</span>
              </div>

            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default QRpage;
